<payee-chip-dropdown
  [selected]="state"
  [placeholder]="'CASES_TABLE.FILTERS.STATE.LABEL' | translate"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="clearFilter()"
>
  <payee-form-field width="wide">
    <payee-autocomplete
      placeholder="{{ 'CASES_TABLE.FILTERS.STATE.PLACEHOLDER' | translate }}"
      [formControl]="stateControl"
      [options]="stateOptions"
    ></payee-autocomplete>
  </payee-form-field>
  <button
    payee-button
    color="primary"
    class="top-margin-10"
    width="wide"
    (click)="applyFilter()"
  >
    {{ "CASES_TABLE.FILTERS.APPLY" | translate }}
  </button>
</payee-chip-dropdown>
